import { apiGet } from './client';

/**
 * TVデモ週間混雑度（バックエンド tv_weekly_* プロファイル）
 */
export function fetchTvWeeklyCongestion({ baseDate, thresholdProfile, signal } = {}) {
  return apiGet(
    '/api/tv-demo/weekly-congestion',
    {
      base_date: baseDate,
      threshold_profile: thresholdProfile,
    },
    { signal },
  );
}
